import { render, staticRenderFns } from "./tree-drop-down-box-single-check.vue?vue&type=template&id=b210610a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./tree-drop-down-box-single-check.vue?vue&type=script&lang=ts&"
export * from "./tree-drop-down-box-single-check.vue?vue&type=script&lang=ts&"
import style0 from "./tree-drop-down-box-single-check.vue?vue&type=style&index=0&id=b210610a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210610a",
  null
  
)

export default component.exports